import styled from 'styled-components';
import { LoadingOutlined } from '@ant-design/icons';

import * as Colors from '../../attrs/colors';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${Colors.WHITE};
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  position: absolute;
`;

export const Logo = styled.img`
  height: 30px;
  display: block;
`;

export const LogoWrapper = styled.div`
  padding: 0 0 20px 0;
`;

export const LoadingIcon = styled(LoadingOutlined).attrs({
  spin: true,
  type: 'loading',
  size: 'large',
})`
  color: ${Colors.BLACK};
`;
